import SEOHead from "../components/SEOHead";
import Header from "../components/Header";
import Hero from "../components/Hero";
import EmergencySection from "../components/EmergencySection";
import Services from "../components/Services";
import Reviews from "../components/Reviews";
import CitiesSection from "../components/CitiesSection";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import FloatingCTA from "../components/FloatingCTA";

export const Home = () => {
  return (
    <>
      <SEOHead
        title="Serrurier Lieusaint (77127) – Dépannage serrurerie urgence 24h/24"
        description="Serrurier Lieusaint disponible 24h/24 pour ouverture de porte, changement de serrure et dépannage serrurerie. Intervention rapide à Lieusaint et dans toute la zone de Sénart. Appelez le 06 68 03 25 61."
      />
      <Header />
      <main>
        <Hero />
        <EmergencySection />
        <Services />
        <Reviews />
        <CitiesSection />
        <ContactForm />
      </main>
      <Footer />
      <FloatingCTA />
    </>
  );
};

export default Home;
